import * as React from 'react';

import { capitalize } from 'lodash';

import AdminSisSyncStatusLabel from 'admin/rostering/components/AdminSisSyncStatusLabel';
import MediaObject from 'components/MediaObject';
import TextBadge, { TextBadgeTextColor } from 'components/TextBadge';
import TitleHeader from 'components/TitleHeader';
// @ts-ignore
import ZopimButton from 'support/components/ZopimButton';

type Props = {
  subtext: string | React.ReactNode;
  status: 'pending' | 'inactive' | 'connected' | 'processing' | 'on hold' | 'paused' | 'failed';
};

export default function AdminSchoolSisSyncHeader({ subtext, status }: Props) {
  function statusColor(status: Props['status']): TextBadgeTextColor {
    switch (status) {
      case 'on hold':
        return 'lava';
      case 'pending':
      case 'failed':
        return 'flame';
      default:
        return 'thunder';
    }
  }

  function AdminSchoolSisDashboardStatus(props: { status: Props['status'] }) {
    const { status } = props;
    const color = statusColor(status);

    return (
      <TextBadge textColor={color} textSize="xxxxsmall">
        {capitalize(status)}
      </TextBadge>
    );
  }

  function renderStatus(status: Props['status']) {
    switch (status) {
      case 'pending':
      case 'failed':
        return <AdminSisSyncStatusLabel status={'pending'} />;
      case 'inactive':
      case 'processing':
      case 'on hold':
      case 'paused':
        return (
          <React.Fragment>
            <MediaObject center figure="right" gutter="xsmall" inline>
              <span>SIS sync</span>
              <AdminSchoolSisDashboardStatus status={status} />
            </MediaObject>
          </React.Fragment>
        );
      case 'connected':
        return <AdminSisSyncStatusLabel status={'active'} />;
    }
  }

  return (
    <TitleHeader
      title={renderStatus(status)}
      subtext={subtext}
      action={<ZopimButton level="secondary" />}
      actionPlacement="right"
      className="AdminSchoolSisSyncHeader"
    />
  );
}
